<template>
  <v-app-bar dark flat class="app-bar" color="primary" app>
    <a
      class="skip-main"
      :href="$route.name === 'about' ? '#about-main-content' : '#main-content'"
      >{{ $route.name === "about" ? "Hopp til innhold" : "Hopp til filter" }}</a
    >
    <router-link
      @focusin.native="onTitleFocused"
      @mousedown.native="titleMousedown = true"
      :class="{ 'black--text': isFocused, 'white--text': !isFocused }"
      @blur.native="isFocused = false"
      :to="{ name: 'home' }"
    >
      <v-row justify="center" align="center" class="pa-0 ma-0 pr-2 pb-1">
        <v-avatar role="link" size="45">
          <img
            :class="{ 'logo-black': isFocused }"
            alt="NVE logo"
            src="../../assets/img/nvelogo.svg"
          />
        </v-avatar>
        <v-toolbar-title role="link" class="pt-1">
          <h1 class="text-h5">Seriekart</h1>
        </v-toolbar-title>
      </v-row>
    </router-link>
    <v-spacer />
    <nav>
      <app-settings-dialog />
      <a
        class="mr-2 ml-2 pa-1 v-btn v-btn--flat v-btn--text theme--dark v-size--default"
        href="mailto:gisstotte@nve.no"
      >
        <v-icon class="mr-2 navbar-link">mdi-email-outline</v-icon>Kontakt oss
      </a>
      <router-link
        :to="{ name: 'about' }"
        class="text-button mr-2 ml-2 pa-1 v-btn v-btn--flat v-btn--text theme--dark v-size--default"
      >
        <v-icon class="mr-2 navbar-link">mdi-information-outline</v-icon>Om
        seriekart
      </router-link>
    </nav>
  </v-app-bar>
</template>

<script>
import AppSettingsDialog from "../../components/common/AppSettingsDialog.vue";

export default {
  components: {
    AppSettingsDialog,
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    onTitleFocused: function() {
      if (!this.titleMousedown) {
        this.isFocused = true;
      }
      this.titleMousedown = false;
    },
  },
  data() {
    return {
      activeNotifications: false,
      isFocused: false,
      titleMousedown: false,
    };
  },
};
</script>
<style>
.logo {
  height: 40px;
  margin-left: 20px;
}
.app-bar {
  left: 0px !important;
  z-index: 10 !important;
}

.logo-black {
  filter: invert(100%) sepia(100%) saturate(11%) hue-rotate(188deg)
    brightness(104%) contrast(103%);
}

.navbar-link {
  color: inherit !important;
}

a.skip-main {
  left: -999px;
  position: absolute;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: -999;
  color: white;
  background: black;
}
a.skip-main:focus,
a.skip-main:active {
  color: #fff;
  left: 20px;
  width: 200px;
  height: 40px;
  padding-top: 4px;
  border: 4px solid #fd0;
  text-align: center;
  position: absolute;
  z-index: 999;
}
</style>
